<template>
  <ul class="footer-navigator flex-middle-x layout-flex-justify-content_space-between">
    <li v-for="(item,index) in activityList"
        @click="actionClickJump(index)">
      <img v-if="index === footerColor" :src="item.imageTrue" alt="">
      <img v-else :src="item.imageFalse" alt="">
      <p :class="{ 'active-color': index === footerColor}">{{item.name}}</p>
    </li>
  </ul>
</template>
<script>
  export default {
    name:'',
    data(){
      return {
        footerColor:0
      }
    },
    props:{
      activeColor:{
        default:Number
      }
    },
    computed:{
      activityList(){
        return [{
          name:'首页',
          imageTrue:require('./image/footer-home-true.png'),
          imageFalse:require('./image/footer-home-false.png')
        },
          {
            name:'影片',
            imageTrue:require('./image/footer-film-true.png'),
            imageFalse:require('./image/footer-film-false.png')
          },
//          {
//            name:'发现',
//            imageTrue:require('./image/footer-findOut-true.png'),
//            imageFalse:require('./image/footer-findOut-false.png')
//          },
          {
            name:'影院',
            imageTrue:require('./image/footer-cinema-true.png'),
            imageFalse:require('./image/footer-cinema-false.png')
          },
          {
            name:'个人',
            imageTrue:require('./image/footer-mine-true.png'),
            imageFalse:require('./image/footer-mine-false.png')
          }]
      }
    },
    methods:{
      actionClickJump: function (index) {
        this.footerColor = index;
        switch (index) {
          case 0 :
            this.$router.replace({name:'HomeView'});
            break;
          case 1 :
            this.$router.replace({name:'FilmPageView'});
            break;
//          case 2 :
//            this.$router.replace({name:'FindPageView'});
//            break;
          case 2 :
            this.$router.replace({name:'CinemaListView'});
            break;
          case 3 :
            this.$router.replace({name:'MinePersonalView'});
            break;
          default :
            break;
        }
      }
    },
    mounted:function(){
      this.footerColor = this.activeColor;
    }
  }
</script>
<style lang="scss" rel="stylesheet/scss" scoped="">
  @import "../assets/styles/index";
  .footer-navigator{
    width:100%;
    height:1.2rem;
    position: fixed;
    left:0;bottom:0;
    z-index:10000;
    border-top:1px solid $color-d;
    background:$color-4;
    padding:0 0.5rem;
    li{
      img{
        width:0.5rem;
      }
      p{
        font-size:0.24rem;
        color:$color-black;
      }
      .active-color{
        font-size:0.24rem;
        color:$color-cebPurple;
      }
    }
  }
</style>
